import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import en from "./assets/locals/en.json";
import ar from "./assets/locals/ar.json";

const langFromUrl = new URLSearchParams(window.location.search)
  .get("lang")
  ?.toLowerCase();
const storedLanguage = localStorage.getItem("language");
const savedLanguage =
  langFromUrl === "en" || langFromUrl === "ar"
    ? langFromUrl
    : storedLanguage || "ar";

const applyDocumentLanguage = (language) => {
  const lang = (language || "ar").split("-")[0];
  document.documentElement.lang = lang;
  document.documentElement.dir = lang === "ar" ? "rtl" : "ltr";
};

applyDocumentLanguage(savedLanguage);

// A map link can open this page with ?lang= for this tab only.
// Do not store that value, or the next character tab forgets the
// language the user is actually browsing in.
if (langFromUrl !== "en" && langFromUrl !== "ar") {
  localStorage.setItem(
    "language",
    storedLanguage === "en" || storedLanguage === "ar" ? storedLanguage : savedLanguage
  );
}

i18n.use(initReactI18next).init({
  resources: {
    en: { translation: en },
    ar: { translation: ar },
  },
  lng: savedLanguage,
  fallbackLng: "ar",
  interpolation: {
    escapeValue: false,
  },
});

i18n.on("languageChanged", (language) => {
  applyDocumentLanguage(language);
});

export default i18n;
